"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var styles = (0, _makeStyles.default)(function () {
  return {
    image: {
      height: "100%",
      left: 0,
      position: "absolute",
      top: 0,
      width: "100%",
      zIndex: 2
    },
    backgroundImage: {
      overflow: "hidden",
      zIndex: 1,
      "& img": {
        filter: "blur(20px)",
        transform: "scale(1.1)"
      }
    },
    hasBlurredBackgroundImage: {
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      "& picture": {
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        overflow: "hidden"
      },
      "& img": {
        height: "auto !important",
        maxWidth: "100%",
        minHeight: "100%",
        width: "auto !important"
      }
    }
  };
});
var _default = styles;
exports.default = _default;